<template>
  <div
    :id="id"
    :ref="refName"
    :data-bs-backdrop="persistModal ? 'static' : null"
    aria-hidden="true"
    class="modal fade"
    tabindex="-1"
  >
    <div :class="`modal-dialog modal-${size} ${isCentered ? 'modal-dialog-centered' : ''}`">
      <div class="modal-content">
        <div class="modal-header">
          <slot name="modal-title">
            <h6 class="modal-title">
              {{ title }}
            </h6>
          </slot>
          <button
            v-if="showCloseButton"
            id="closeModal"
            aria-label="Close"
            class="btn-close"
            data-bs-dismiss="modal"
            type="button"
            @click="hideModal"
          ></button>
        </div>
        <div class="modal-body">
          <slot name="modal-body">
            {{ modalContent }}
          </slot>
        </div>
        <div v-if="showFooter" class="modal-footer">
          <slot name="modal-footer">
            <Button
              v-if="showCancelButton"
              :is-disabled="disableCancelBtn || isLoading"
              size="sm"
              type="button"
              variant="secondary"
              @click="hideModal"
            >
              {{ cancelText }}
            </Button>
            <Button
              v-if="showSubmitButton"
              id="submit-modal"
              :is-disabled="disableSubmitBtn"
              :is-loading="isLoading"
              :variant="submitButtonVariant"
              size="sm"
              type="button"
              @click="$emit('action:submit')"
            >
              {{ submitText }}
            </Button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { Modal } from "bootstrap";

export default {
  name: "Modal",
  props: {
    id: {
      type: String,
      default: "default-modal",
    },
    refName: {
      type: String,
      default: "default-modal-ref",
    },
    show: {
      type: Boolean,
      default: false,
    },
    isCentered: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "sm",
    },
    title: {
      type: String,
      default: "Modal Title",
    },
    modalContent: {
      type: String,
      default: "Modal Content",
    },
    cancelText: {
      type: String,
      default: "",
    },
    disableCancelBtn: {
      type: Boolean,
      default: false,
    },
    disableSubmitBtn: {
      type: Boolean,
      default: false,
    },
    submitText: {
      type: String,
      default: "",
    },
    submitButtonVariant: {
      type: String,
      default: "primary",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    showCancelButton: {
      type: Boolean,
      default: true,
    },
    showSubmitButton: {
      type: Boolean,
      default: true,
    },
    persistModal: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    let modalInstance = ref(null);

    onMounted(() => {
      const modal = document.getElementById(props.id);
      if (modal && Modal.getOrCreateInstance(modal)) {
        modalInstance.value = Modal.getOrCreateInstance(modal);
        modal.addEventListener("hidden.bs.modal", function (event) {
          hideModal();
        });
      }
    });

    watch(
      props,
      (value) => {
        if (modalInstance.value) {
          if (value.show) modalInstance.value.show();
          else modalInstance.value.hide();
        }
      },
      { deep: true }
    );

    const showModal = () => {
      emit("action:show-modal");
    };

    const hideModal = () => {
      emit("action:hide-modal", "fromModalComponent");
    };

    return {
      showModal,
      hideModal,
    };
  },
};
</script>

<style></style>
